import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { api, errMsg, fmtDate } from "../../lib/api";
import { useDebouncedList } from "../../lib/useDebouncedList";
import { btnGhost, inputCls } from "../../components/ui";

function ReviewRow({ r, onDone }) {
  const [reason, setReason] = useState("");
  const moderate = async () => {
    try { await api.post(`/admin/reviews/${r.id}/moderate`, { hidden: !r.hidden, reason }); toast.success(r.hidden ? "Avaliação visível" : "Avaliação ocultada"); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap items-start gap-3 p-3 text-sm" data-testid={`admin-review-${r.id}`}>
      <div className="min-w-[240px] flex-1">
        <p className="flex items-center gap-1 font-medium">{Array.from({ length: 5 }, (_, i) => <Star key={i} className={`h-3.5 w-3.5 ${i < r.rating ? "fill-bo-yellow text-bo-yellow" : "text-gray-300"}`} />)}<span className="ml-2">{r.product_name}</span></p>
        <p className="text-gray-700">{r.comment || <em className="text-gray-400">sem comentário</em>}</p>
        <p className="text-xs text-gray-500">{r.user_name} · {fmtDate(r.created_at)}{r.hidden && ` · ocultada por ${r.moderated_by}: ${r.moderation_reason}`}</p>
      </div>
      <input placeholder="Motivo" value={reason} onChange={(e) => setReason(e.target.value)} className="w-44 rounded-lg border border-gray-200 px-2 py-1 text-sm" data-testid={`admin-review-reason-${r.id}`} />
      <button disabled={reason.trim().length < 3} onClick={moderate} className={`${btnGhost} px-3 py-1.5 ${r.hidden ? "" : "text-red-600"}`} data-testid={`admin-review-toggle-${r.id}`}>{r.hidden ? "Mostrar" : "Ocultar"}</button>
    </div>
  );
}

export default function AdminReviews() {
  const [f, setF] = useState({ status: "", q: "", page: 1 });
  const [d, load] = useDebouncedList("/admin/reviews", f, { items: [], total: 0, limit: 25 });
  const pages = Math.max(1, Math.ceil(d.total / d.limit));
  return (
    <div className="flex flex-col gap-3" data-testid="admin-reviews">
      <div className="bo-card flex flex-wrap gap-3 p-4">
        <input placeholder="Pesquisar comentário ou cliente" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value, page: 1 })} className={`${inputCls} sm:w-72`} data-testid="admin-reviews-search" />
        <select value={f.status} onChange={(e) => setF({ ...f, status: e.target.value, page: 1 })} className={`${inputCls} w-auto`} data-testid="admin-reviews-status"><option value="">Todas</option><option value="visible">Visíveis</option><option value="hidden">Ocultadas</option></select>
        <span className="ml-auto self-center text-sm text-gray-500">{d.total} avaliações · página {f.page}/{pages}</span>
        <button disabled={f.page <= 1} onClick={() => setF({ ...f, page: f.page - 1 })} className={btnGhost} data-testid="admin-reviews-prev">‹</button>
        <button disabled={f.page >= pages} onClick={() => setF({ ...f, page: f.page + 1 })} className={btnGhost} data-testid="admin-reviews-next">›</button>
      </div>
      <p className="text-xs text-gray-500">Avaliações ocultadas deixam de aparecer no site e de contar para a classificação. Fotografias nas avaliações e reclamações formais ainda não estão disponíveis.</p>
      <div className="bo-card divide-y divide-gray-50">{d.items.map((r) => <ReviewRow key={`${r.id}-${!!r.hidden}`} r={r} onDone={load} />)}{!d.items.length && <p className="p-4 text-sm text-gray-500">Sem avaliações.</p>}</div>
    </div>
  );
}
